//
//
//
//
//
//
//
//
//

import { CalendarIcon } from 'vue-feather-icons'
import TaskDurationContent from '@/components/tasks/TaskDurationContent'
import TaskDetailsItem from '@/components/tasks/TaskDetailsItem'

// noinspection JSUnusedGlobalSymbols
export default {
  name: 'TaskDetailsDuration',
  components: {
    TaskDetailsItem,
    TaskDurationContent,
    CalendarIcon
  },
  props: {
    task: {
      type: Object,
      default () {
        return {}
      }
    }
  }
}
